import React from "react";

export default function EmailVerifyModal({ onConfirm, onRetry }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg w-11/12 max-w-md p-6">
        <h2 className="text-2xl font-bold mb-4">Payment Required</h2>
        <p className="mb-4">
          Your registration is complete! To activate your account, please complete
          your membership payment.
        </p>
        <p className="mb-6 text-sm text-gray-600">
          An administrator will approve your account once payment is confirmed.
          You'll be able to log in after approval.
        </p>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onRetry}
            className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-[#800000] text-white rounded hover:bg-[#9b0000]"
          >
            Proceed to Payment
          </button>
        </div>
      </div>
    </div>
  );
}
